"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DayPartHourOfDayInnerToJSON = exports.DayPartHourOfDayInnerFromJSONTyped = exports.DayPartHourOfDayInnerFromJSON = exports.instanceOfDayPartHourOfDayInner = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the DayPartHourOfDayInner interface.
 */
function instanceOfDayPartHourOfDayInner(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfDayPartHourOfDayInner = instanceOfDayPartHourOfDayInner;
function DayPartHourOfDayInnerFromJSON(json) {
    return DayPartHourOfDayInnerFromJSONTyped(json, false);
}
exports.DayPartHourOfDayInnerFromJSON = DayPartHourOfDayInnerFromJSON;
function DayPartHourOfDayInnerFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'min': !(0, runtime_1.exists)(json, 'min') ? undefined : json['min'],
        'max': !(0, runtime_1.exists)(json, 'max') ? undefined : json['max'],
    };
}
exports.DayPartHourOfDayInnerFromJSONTyped = DayPartHourOfDayInnerFromJSONTyped;
function DayPartHourOfDayInnerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'min': value.min,
        'max': value.max,
    };
}
exports.DayPartHourOfDayInnerToJSON = DayPartHourOfDayInnerToJSON;
